import type { FC } from 'react';

import SmallTooltip, { SmallTooltipProps } from '../SmallTooltip';

const SIDER_TOOLTIP_HORIZONTAL_PADDING = '0 1rem';
const SIDER_TRAILING_ACTION_SLOT_WIDTH = 28;

export interface SiderTooltipProps extends Omit<SmallTooltipProps, 'align' | 'padding' | 'placement'> {
    /** Number of right-aligned action slots that sit after the tooltip trigger. */
    trailingActions?: number;
}

/**
 * Keeps right-facing left-sider tooltips on one visual rail. Navigation rows
 * reserve space for any trailing actions while action buttons use the rail
 * directly.
 */
const SiderTooltip: FC<SiderTooltipProps> = ({ trailingActions = 0, ...props }): JSX.Element => (
    <SmallTooltip
        {...props}
        align={{ offset: [trailingActions * SIDER_TRAILING_ACTION_SLOT_WIDTH, 0] }}
        padding={SIDER_TOOLTIP_HORIZONTAL_PADDING}
        placement='right'
    />
);

export default SiderTooltip;
